import { apiBffMobileV2Carts } from './api'

export const updateCouponInCart = async (cartId: string, couponId: string, providerId: string): Promise<void> => {
  await apiBffMobileV2Carts.put(`/${cartId}/coupons/${couponId}?providerId=${providerId}`)
}
